export enum DirectDebitFormField {
  AccountHolderConfirmation = 'accountHolderConfirmation',
  AccountName = 'accountName',
  AccountNumber = 'accountNumber',
  IBAN = 'iban',
  PaperlessPreference = 'paperlessPreference',
  PaymentDate = 'paymentDate',
  SortCode = 'sortCode',
  TermsAndConditions = 'termsAndConditions',
  PaymentToken = 'paymentToken',
}
